import DashboardLayout from "@/views/Layout/DashboardLayout.vue";
import AuthLayout from "@/views/Pages/AuthLayout.vue";

import NotFound from "@/views/NotFoundPage.vue";

const routes = [
  {
    path: "/",
    redirect: "manage-job",
    component: DashboardLayout,
    children: [
      {
        path: "/manage-rate",
        name: "manageRate",
        meta: {
          requiresAuth: true,
          role: ["admin", "superadmin"],
        },
        component: () =>
          import(
            /* webpackChunkName: "demo" */ "../views/Pages/Admin/Rate/ManageRate.vue"
          ),
      },
      {
        path: "/manage-rate/:id",
        name: "manageRateId",
        meta: {
          requiresAuth: true,
          role: ["admin", "superadmin"],
        },
        component: () =>
          import(
            /* webpackChunkName: "demo" */ "../views/Pages/Admin/Rate/ManageRateId.vue"
          ),
      },
      {
        path: "/create-rate",
        name: "createRate",
        meta: {
          requiresAuth: true,
          role: ["admin", "superadmin"],
        },
        component: () =>
          import(
            /* webpackChunkName: "demo" */ "../views/Pages/Admin/Rate/CreateRate.vue"
          ),
      },
      {
        path: "/manage-job",
        name: "manageJob",
        meta: {
          requiresAuth: true,
          role: ["admin", "superadmin"],
        },
        component: () =>
          import(
            /* webpackChunkName: "demo" */ "../views/Pages/Admin/Job/ManageJob.vue"
          ),
      },
      {
        path: "/create-job",
        name: "createJob",
        meta: {
          requiresAuth: true,
          role: ["admin", "superadmin"],
        },
        component: () =>
          import(
            /* webpackChunkName: "demo" */ "../views/Pages/Admin/Job/CreateJob.vue"
          ),
      },
      {
        path: "/job-detail/:id",
        name: "jobDeatil",
        meta: {
          requiresAuth: true,
          role: ["admin", "superadmin"],
        },
        component: () =>
          import(
            /* webpackChunkName: "demo" */ "../views/Pages/Admin/Job/JobDetail.vue"
          ),
      },
      {
        path: "/manage-job/:id",
        name: "manageJobId",
        meta: {
          requiresAuth: true,
          role: ["admin", "superadmin"],
        },
        component: () =>
          import(
            /* webpackChunkName: "demo" */ "../views/Pages/Admin/Job/ManageJobId.vue"
          ),
      },
      {
        path: "/manage-item",
        name: "manageItem",
        meta: {
          requiresAuth: true,
          role: ["admin", "superadmin"],
        },
        component: () =>
          import(
            /* webpackChunkName: "demo" */ "../views/Pages/Admin/Item/ManageItem.vue"
          ),
      },
      {
        path: "/manage-item/:id",
        name: "manageItemId",
        meta: {
          requiresAuth: true,
          role: ["admin", "superadmin"],
        },
        component: () =>
          import(
            /* webpackChunkName: "demo" */ "../views/Pages/Admin/Item/ManageItemId.vue"
          ),
      },
      {
        path: "/manage-customer",
        name: "manageCustomer",
        meta: {
          requiresAuth: true,
          role: ["admin", "superadmin"],
        },
        component: () =>
          import(
            /* webpackChunkName: "demo" */ "../views/Pages/Admin/Customer/ManageCustomer.vue"
          ),
      },
      {
        path: "/manage-customer/:id",
        name: "manageCustomerId",
        meta: {
          requiresAuth: true,
          role: ["admin", "superadmin"],
        },
        component: () =>
          import(
            /* webpackChunkName: "demo" */ "../views/Pages/Admin/Customer/ManageCustomerId.vue"
          ),
      },
      {
        path: "/register-customer",
        name: "registerCustomer",
        meta: {
          requiresAuth: true,
          role: ["admin", "superadmin"],
        },
        component: () =>
          import(
            /* webpackChunkName: "demo" */ "../views/Pages/Admin/Customer/RegisterCustomer.vue"
          ),
      },
      {
        path: "/manage-driver",
        name: "manageDriver",
        meta: {
          requiresAuth: true,
          role: ["superadmin", "admin"],
        },
        component: () =>
          import(
            /* webpackChunkName: "demo" */ "../views/Pages/Admin/Driver/ManageDriver.vue"
          ),
      },
      {
        path: "/manage-driver/:id",
        name: "manageDriverId",
        meta: {
          requiresAuth: true,
          role: ["superadmin", "admin"],
        },
        component: () =>
          import(
            /* webpackChunkName: "demo" */ "../views/Pages/Admin/Driver/ManageDriverId.vue"
          ),
      },
      {
        path: "/manage-admin",
        name: "manageAdmin",
        meta: {
          requiresAuth: true,
          role: ["superadmin", "admin"],
        },
        component: () =>
          import(
            /* webpackChunkName: "demo" */ "../views/Pages/Admin/Admin/ManageAdmin.vue"
          ),
      },
      {
        path: "/manage-car",
        name: "manageCar",
        meta: {
          requiresAuth: true,
          role: ["admin", "superadmin"],
        },
        component: () =>
          import(
            /* webpackChunkName: "demo" */ "../views/Pages/Admin/Car/ManageCar.vue"
          ),
      },
      {
        path: "/manage-car/:id",
        name: "CarDetails",
        meta: {
          requiresAuth: true,
          role: ["superadmin", "admin"],
        },
        component: () =>
          import(
            /* webpackChunkName: "demo" */ "../views/Pages/Admin/Car/CarDetails.vue"
          ),
      },
      {
        path: "/manage-category-car",
        name: "manageCategoryCar",
        meta: {
          requiresAuth: true,
          role: ["admin", "superadmin"],
        },
        component: () =>
          import(
            /* webpackChunkName: "demo" */ "../views/Pages/Admin/Car/Category/ManageCategoryCar.vue"
          ),
      },
      {
        path: "/report-delivery",
        name: "ReportDelivery",
        meta: {
          requiresAuth: true,
          role: ["admin", "superadmin"],
        },
        component: () =>
          import(
            /* webpackChunkName: "demo" */ "../views/Pages/Admin/Report/ManageDelivery.vue"
          ),
      },
      // {
      //   path: "/dashboard",
      //   name: "dashboard",
      //   meta: {
      //     requiresAuth: true,
      //   },
      //   // route level code-splitting
      //   // this generates a separate chunk (about.[hash].js) for this route
      //   // which is lazy-loaded when the route is visited.
      //   component: () =>
      //     import(/* webpackChunkName: "demo" */ "../views/Dashboard.vue"),
      // },
      // {
      //   path: "/icons",
      //   name: "icons",
      //   component: () =>
      //     import(/* webpackChunkName: "demo" */ "../views/Icons.vue"),
      // },
      // {
      //   path: "/profile",
      //   name: "profile",
      //   component: () =>
      //     import(
      //       /* webpackChunkName: "demo" */ "../views/Pages/UserProfile.vue"
      //     ),
      // },
      // {
      //   path: "/maps",
      //   name: "maps",
      //   component: () =>
      //     import(/* webpackChunkName: "demo" */ "../views/GoogleMaps.vue"),
      // },
      // {
      //   path: "/tables",
      //   name: "tables",
      //   component: () =>
      //     import(/* webpackChunkName: "demo" */ "../views/RegularTables.vue"),
      // },
    ],
  },
  {
    path: "/login",
    name: "login",
    component: () =>
      import(/* webpackChunkName: "demo" */ "../views/Pages/Login.vue"),
  },
  {
    path: "/auth",
    // redirect: 'login',
    component: AuthLayout,
    children: [
      // {
      //   path: "login",
      //   name: "authLogin",
      //   component: () =>
      //     import(/* webpackChunkName: "demo" */ "../views/Pages/Login.vue"),
      // },
      // {
      //   path: "register",
      //   name: "register",
      //   component: () =>
      //     import(/* webpackChunkName: "demo" */ "../views/Pages/Register.vue"),
      // },
      {
        path: "home",
        name: "home",
        meta: {
          requiresAuth: true,
          role: ["driver"],
        },
        component: () =>
          import(
            /* webpackChunkName: "demo" */ "../views/Pages/Driver/Home.vue"
          ),
      },
      {
        path: "driver/job/details/:id",
        name: "workAfter",
        meta: {
          requiresAuth: true,
          role: ["driver"],
        },
        component: () =>
          import(
            /* webpackChunkName: "demo" */ "../views/Pages/Driver/WorkAfter.vue"
          ),
      },
      {
        path: "profiledetail",
        name: "profiledetail",
        meta: {
          requiresAuth: true,
          role: ["driver"],
        },
        component: () =>
          import(
            /* webpackChunkName: "demo" */ "../views/Pages/Driver/ProfileDetail.vue"
          ),
      },
      {
        path: "listcar",
        name: "listcar",
        meta: {
          requiresAuth: true,
          role: ["driver"],
        },
        component: () =>
          import(
            /* webpackChunkName: "demo" */ "../views/Pages/Driver/ListCar.vue"
          ),
      },
      {
        path: "listreport",
        name: "listreport",
        meta: {
          requiresAuth: true,
          role: ["driver"],
        },
        component: () =>
          import(
            /* webpackChunkName: "demo" */ "../views/Pages/Driver/ListReport.vue"
          ),
      },
      {
        path: "ListCarDetail",
        name: "ListCarDetail",
        meta: {
          requiresAuth: true,
          role: ["driver"],
        },
        component: () =>
          import(
            /* webpackChunkName: "demo" */ "../views/Pages/Driver/ListCarDetail.vue"
          ),
      },
      {
        path: "ListCarMantainace",
        name: "ListCarMantainace",
        meta: {
          requiresAuth: true,
          role: ["driver"],
        },
        component: () =>
          import(
            /* webpackChunkName: "demo" */ "../views/Pages/Driver/ListCarMantainace.vue"
          ),
      },
      { path: "*", component: NotFound },
    ],
  },
];

export default routes;
